import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getParentshipTypes } from "../../slices/codeBookSlice";

export const useGetParentshipTypes = () => {
  const parentshipTypes = useSelector(
    (state: RootState) => state.codeBook.parentshipTypes
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getParentshipTypes());
  }, [dispatch]);

  return parentshipTypes;
};
